module.exports = __webpack_public_path__ + "static/media/3.7a03327c.jpeg";